if (!customElements.get('seal-image-preview')) {
  customElements.define(
    'seal-image-preview',
    class SealImagePreview extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.openButton = this.querySelector('[data-seal-image-preview-open]');
        this.modal = this.querySelector('[data-seal-image-preview-modal]');
        this.closeButton = this.querySelector('[data-seal-image-preview-close]');
        this.dialog = this.querySelector('[data-seal-image-preview-dialog]');

        if (!this.openButton || !this.modal || !this.closeButton || !this.dialog) return;

        this.modalParent = this.modal.parentNode;
        this.modalNextSibling = this.modal.nextSibling;
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleModalClick = this.handleModalClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.openButton.addEventListener('click', this.open);
        this.closeButton.addEventListener('click', this.close);
        this.modal.addEventListener('click', this.handleModalClick);
      }

      disconnectedCallback() {
        this.openButton?.removeEventListener('click', this.open);
        this.closeButton?.removeEventListener('click', this.close);
        this.modal?.removeEventListener('click', this.handleModalClick);
        document.removeEventListener('keydown', this.handleKeydown);

        if (this.modal?.parentNode === document.body) {
          this.modal.remove();
        }
      }

      open() {
        this.previouslyFocused = document.activeElement;
        if (this.modal.parentNode !== document.body) {
          document.body.appendChild(this.modal);
        }

        this.modal.hidden = false;
        this.modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('seal-image-preview-lock');
        document.addEventListener('keydown', this.handleKeydown);

        requestAnimationFrame(() => {
          this.modal.classList.add('is-open');
          this.closeButton.focus({ preventScroll: true });
        });
      }

      close() {
        this.modal.classList.remove('is-open');
        this.modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('seal-image-preview-lock');
        document.removeEventListener('keydown', this.handleKeydown);

        window.setTimeout(() => {
          if (!this.modal.classList.contains('is-open')) {
            this.modal.hidden = true;
            if (this.modalParent?.isConnected && this.modal.parentNode === document.body) {
              this.modalParent.insertBefore(this.modal, this.modalNextSibling);
            }
          }
        }, 180);

        if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
          this.previouslyFocused.focus({ preventScroll: true });
        }
      }

      handleModalClick(event) {
        if (event.target === this.modal) {
          this.close();
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && !this.modal.hidden) {
          this.close();
        }
      }
    }
  );
}
